import fetchHandler from './Handler';

export const GetAllNotifications = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admin/notification', // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};
export const MarkNotificationAsRead = async (data: any, id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'PATCH',
			endpoint: `admin/notification/${data}/${id}/read`,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const MarkAllNotificationsAsRead = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'PATCH',
			endpoint: `admin/notification/read-all
`,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
